import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import CinemaIntro from "../../components/CinemaIntro";
import PrevNotice from "../../components/PrevNotice";
import FAQNotice from "../../components/FAQNotice";
import AutoHotMoviePreview from "../../components/Auto/AutoHotMoviePreview";
import AutoBoxOfficeRanking from "../../components/Auto/AutoBoxOfficeRanking";
import AutoBestTop8Card from "../../components/Auto/AutoBestTop8Card";
import AutoComingSoon from "../../components/Auto/AutoComingSoonTop4";
import { useAuth } from "../../AuthContext";
import { getSessionFunc } from "../../api/func/userFunc";
import HomeMobile from "./Mobile";

const MainWrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  overflow-x: hidden;
  position: relative;
`;

const MainContainer1 = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 30px;

  @media (max-width: 768px) {
    flex-direction: column;
    margin-top: 0;
  }
`;

const LeftContainer = styled.span`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;

  /* 768px 이하에서는 맨 아래로 이동 */
  @media (max-width: 768px) {
    order: 3;
    flex-direction: row;
    width: 100%;
  }
`;

const MidContainer = styled.span`
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 10px;

  img {
    width: 100%;
    height: auto;
  }

  /* MidContainer는 항상 두 번째 */
  @media (max-width: 1024px) {
    order: 1;
  }
`;

const RightContainer = styled.span`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;

  /* 1024px 이하에서 MidContainer 아래로 이동 */
  @media (max-width: 1024px) {
    order: 2;
  }

  /* 768px 이하에서 MidContainer 바로 아래로 이동 */
  @media (max-width: 768px) {
    order: 2;
    justify-content: space-between;
    flex-direction: row;
    width: 100%;
  }
`;

const MainContainer2Banner = styled.div`
  width: 100%;
  margin: 10px 0;
  text-align: center;

  img {
    width: 100%;
    height: auto;
  }
`;

const MainContainer3 = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
  text-align: center;

  /* 작은 화면에서 flex-direction과 order를 조정 */
  @media (max-width: 992px) {
    flex-direction: column;
    width: 100%;
  }
`;

const MainContainer4 = styled.div`
  display: flex;
  justify-content: center;
  align-items: stretch;
  margin: 10px 0;
  text-align: center;

  /* Adjust flex-direction and item order for smaller screens */
  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center; /* Center items horizontally */
  }

  span {
    flex: 1;
    padding-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 65px;

    img {
      max-height: 100%;
      width: auto;
    }
  }
`;

const NoticeBanner = styled.span`
  flex: 40%;
  margin-right: 5px;
  border: 1px solid #dddddd;

  /* Order adjustment for smaller screens */
  @media (max-width: 1024px) {
    order: 1;
    margin-right: 0; /* Remove right margin for vertical alignment */
    margin-bottom: 5px; /* Add bottom margin for spacing between items */
    width: 100%;
  }
`;

const GuideBanner = styled.span`
  flex: 30%;
  margin-right: 5px;
  border: 1px solid #dddddd;

  /* Order adjustment for smaller screens */
  @media (max-width: 1024px) {
    order: 2;
    margin-right: 0;
    margin-bottom: 5px;
    width: 100%;
  }
`;

const PurchaseBanner = styled.span`
  flex: 30%;
  border: 1px solid #dddddd;

  /* Order adjustment for smaller screens */
  @media (max-width: 1024px) {
    order: 3;
    width: 100%;
  }
`;

const ComingSoonWrapper = styled.div`
  width: 40%;
  margin-right: 10px; /* Add some space between the two components */

  /* 작은 화면에서 HotMoviePreviewWrapper 아래로 이동 */
  @media (max-width: 992px) {
    order: 1;
    width: 100%; /* Make it take full width in column layout */
    margin-right: 0; /* Remove margin for vertical alignment */
    margin-top: 10px; /* Add top margin for spacing between items */
  }
`;

const HotMoviePreviewWrapper = styled.div`
  width: 60%;
  margin-left: 10px; /* Add some space between the two components */

  /* 작은 화면에서 첫 번째로 이동 */
  @media (max-width: 992px) {
    order: 2;
    width: 100%; /* Make it take full width in column layout */
    margin-left: 0; /* Remove margin for vertical alignment */
  }
`;
const SubBannerWrapper  = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;
// [2026-07-22 SEO] 홈 하단 서비스 소개(검색 노출용 본문 텍스트). 사람·봇 동일(클로킹 아님).
const IntroSection = styled.section`
  max-width: 1200px;
  margin: 24px auto 40px;
  padding: 20px 24px;
  color: #555;
  line-height: 1.7;
  border-top: 1px solid #eee;
  h1 { font-size: 18px; color: #222; margin: 0 0 10px; font-weight: 700; }
  p { font-size: 14px; margin: 6px 0; }
`;
export default function Home() {
  const { isLoggedIn, setIsLoggedIn, setUser } = useAuth();
  const [bannerPaths, setBannerPaths] = useState({
    mainBanner: "",
    subBanner: "",
    csCenterBanner: "",
    guideBanner: "",
    purchaseBanner: "",
  });

  // 모바일 폭이면 새 모바일 메인, 아니면 기존 데스크톱 메인 (Navigator와 동일 768px 기준)
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" && window.innerWidth <= 768
  );
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    fetch("/control/getBannerPath")
      .then((res) => res.json())
      .then((data) => {
        setBannerPaths({
          mainBanner: data.main_banner || "",
          subBanner: data.sub_banner || "",
          csCenterBanner: data.customer_center || "",
          guideBanner: data.ticketing_guide || "",
          purchaseBanner: data.faq || "",
        });
      })
      .catch((error) => console.error("메인베너요청 실패", error));
  }, []);

  useEffect(() => {
    // console.log("HP");
    const storedUser = JSON.parse(sessionStorage.getItem("user"));

    // id로 session 데이터 가져옴
    const getSession = async (phone_number) => {
      const returnSession = await getSessionFunc(phone_number);
      return returnSession;
    };

    //로그인 상태 판별
    const isLoginFunc = async (storedUser) => {
      // console.log(`=== start is login 3 ===`);
      // 세션 스토리지의 id를 가져온다.
      if (
        storedUser !== null &&
        (storedUser.phone_number !== null ||
          storedUser.phone_number !== undefined)
      ) {
        try {
          // console.log("session 값이 있음");
          // console.log(`storedUser.phone_number : ${storedUser.phone_number}`);
          const returnSession = await getSession(storedUser.phone_number);
          // console.log(returnSession);
          // console.log(JSON.stringify(returnSession));
          // console.log(`code : ${returnSession.code} `);
          if (returnSession.code == 200 && returnSession.result !== 0) {
            // 서버 세션이 남아있을 경우
            // console.log("서버 session true");
            setIsLoggedIn(true);
            setUser(storedUser);
          } else {
            // 서버 Redis에 세션이 없을 경우
            // console.log("서버 session false");
            setIsLoggedIn(false);
            setUser(null);
            sessionStorage.removeItem("user");
          }
        } catch (e) {
          console.log("로그인 판별 에러 : e");
        }
      } else {
        // 세션 스토리지 아이디가 없을 경우
        // console.log("session false");
        setIsLoggedIn(false);
        setUser(null);
      }
      // console.log(`=== end is login ===`);
    };
    isLoginFunc(storedUser);
  }, [isLoggedIn]);

  if (isMobile) return <HomeMobile />;

  return (
    <MainWrapper>
      <MainContainer1>
        <LeftContainer className="left-main-container1">
          <PrevNotice />
          <FAQNotice />
        </LeftContainer>
        <MidContainer className="mid-main-container1">
          <AutoBestTop8Card />
          <SubBannerWrapper>
            <img src={bannerPaths.subBanner} alt="sub_banner" />
          </SubBannerWrapper>
        </MidContainer>
        <RightContainer className="right-main-container1">
          <CinemaIntro />
          <AutoBoxOfficeRanking />
        </RightContainer>
      </MainContainer1>
      {/* 2026-06-27 "가격고민NO" 메인 배너 비활성화 (사용자 요청). 복구하려면 아래 주석 해제. */}
      {/* <MainContainer2Banner>
        <img src={bannerPaths.mainBanner} alt="main-banner" />
      </MainContainer2Banner> */}
      <MainContainer3>
        <ComingSoonWrapper>
          <AutoComingSoon />
        </ComingSoonWrapper>
        <HotMoviePreviewWrapper>
          <AutoHotMoviePreview />
        </HotMoviePreviewWrapper>
      </MainContainer3>
      <MainContainer4>
        <NoticeBanner>
          <Link to={"/cscenter/board/1"}>
            <img src={bannerPaths.csCenterBanner} alt="notice-banner" />
          </Link>
        </NoticeBanner>
        <GuideBanner>
          <Link to={"/cscenter/board/guide"}>
            <img src={bannerPaths.guideBanner} alt="guide-banner" />
          </Link>
        </GuideBanner>
        <PurchaseBanner>
          <Link to={"/cscenter/board/3"}>
            <img src={bannerPaths.purchaseBanner} alt="purchase-banner" />
          </Link>
        </PurchaseBanner>
      </MainContainer4>

      <IntroSection>
        <h1>씨네트리 - CGV·롯데시네마·메가박스 영화 예매대행</h1>
        <p>
          씨네트리는 CGV·롯데시네마·메가박스 영화표를 고객 대신 예매해 드리는 국내 영화 예매대행 서비스입니다.
          원하는 지역·극장·상영시간을 선택하면 씨네트리가 대신 예매를 진행해 드립니다.
        </p>
        <p>
          박스오피스 순위, 상영중·상영예정 영화 정보, 전국 극장 정보와 상영시간표를 한 곳에서 확인하고
          영화표를 편리하게 예매·할인받으세요.
        </p>
      </IntroSection>
    </MainWrapper>
  );
}
